
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.717 5.851A1.002 1.002 0 0126.24 5c0-.55.45-1 1-1h6.46c.55 0 1 .45 1 1 0 .37-.204.695-.505.868l.078.983c.413.123.717.507.717.959 0 .398-.23.743-.57.904L35.61 23.7v.08c0 .66.41 1.4.89 2.26l.014.026c.657 1.183 1.396 2.516 1.396 4.214v2.891a.99.99 0 010 .398v13.692a.99.99 0 010 .398V53.2c.02 1.49-1.19 2.69-2.68 2.69H25.7A2.7 2.7 0 0123 53.2V30.28c0-1.71.75-3.06 1.41-4.24.48-.86.89-1.6.89-2.26l1.192-15.082a1.003 1.003 0 01-.542-.888c0-.441.29-.818.688-.95l.08-1.009zM35.94 46.46V34.37H25.01v12.09h10.93zm-10.93 2h10.93v4.74a.7.7 0 01-.7.69h-9.53c-.39 0-.7-.31-.7-.69v-4.74zm10.93-18.18v2.09H25.01v-2.09c0-1.19.59-2.25 1.16-3.27l.024-.045c.553-1.005 1.116-2.031 1.116-3.115l1.196-15.04h3.927l1.197 15.01c.02 1.16.59 2.19 1.15 3.19.57 1.02 1.16 2.08 1.16 3.27zM28.666 6.81l.064-.8h3.48l.064.8h-3.608z"}})])
          )
        }
      }
    